import {
  /** FETCH APPLICATION  */
  FETCH_TRIGERAPPLICATION_FULFILLED,
  FETCH_TRIGERAPPLICATION_REJECTED,
  FETCH_TRIGERAPPLICATION_PENDING,
  RESET_TRIGERAPPLICATION,
} from "../../actions/application/trigerApplicationStatus";
const initialState = {
  done: false,
  error: false,
  spinner: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRIGERAPPLICATION_PENDING:
      return {
        done: false,
        spinner: true,
        error: false,
      };
    case FETCH_TRIGERAPPLICATION_FULFILLED:
      return {
        ...state,
        trigerApplication: action.payload,
        done: true,
        error: false,
        spinner : false
      };
    case FETCH_TRIGERAPPLICATION_REJECTED:
      return {
        ...state,
        error: action.payload,
        done: false,
        spinner : false
      };
    case RESET_TRIGERAPPLICATION:
      return {
        initialState,
        done: false,
        error: false,
        spinner : false
      };
    default:
      return state;
  }
};
